import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';

const SPLASH_FALLBACK_TIMEOUT_MS = 10000;

let fallbackTimeout: number | null = null;
let splashHidden = false;

const hideSplash = async (): Promise<void> => {
  if (!Capacitor.isNativePlatform() || splashHidden) {
    return;
  }

  splashHidden = true;
  if (fallbackTimeout !== null) {
    window.clearTimeout(fallbackTimeout);
    fallbackTimeout = null;
  }

  try {
    await SplashScreen.hide();
  } catch (error) {
    console.warn('Could not hide the native splash screen.', error);
  }
};

export const startNativeSplashFallback = (): void => {
  if (!Capacitor.isNativePlatform() || fallbackTimeout !== null || splashHidden) {
    return;
  }

  fallbackTimeout = window.setTimeout(() => {
    fallbackTimeout = null;
    void hideSplash();
  }, SPLASH_FALLBACK_TIMEOUT_MS);
};

export const completeNativeStartup = (): void => {
  if (!Capacitor.isNativePlatform() || splashHidden) {
    return;
  }

  // Let React paint the authenticated header before revealing the WebView.
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => void hideSplash());
  });
};
